import { gql } from "@apollo/client";

export const GET_DOCUMENTS = gql`
  query GetDocuments(
    $first: Int
    $page: Int
    $orderBy: [QueryDocumentsOrderByOrderByClause!]
  ) {
    documents(first: $first, page: $page, orderBy: $orderBy) {
      paginatorInfo {
        currentPage
        total
        lastPage
        hasMorePages
      }
      data {
        id
        title
        slug
        active
        placement
        row_order
        getFileUrl
      }
    }
  }
`;

export const GET_DOCUMENTS_ORDER = gql`
  query GetDocumentsOrder(
    $first: Int
    $page: Int
    $orderBy: [QueryDocumentsOrderByOrderByClause!]
  ) {
    documents(first: $first, page: $page, orderBy: $orderBy) {
      paginatorInfo {
        currentPage
        total
        lastPage
        hasMorePages
      }
      data {
        id
        row_order
      }
    }
  }
`;
